import { createChannelEvent } from 'redux/services/channelEvents'
import buildChannelEventObject from '../../../utils/functions/buildChannelEventObject'
import { AnalyticsServiceSettings } from 'models/AnalyticsServiceSettings'

interface MakeFacebookCapiAnalyticsPluginProps {
  organizationId: string
  dispatch: (action: any) => void
  settings: AnalyticsServiceSettings[]
}

export const makeFacebookCapiAnalyticsPlugin = ({
  organizationId,
  dispatch,
  settings,
}: MakeFacebookCapiAnalyticsPluginProps) => {
  // Find Facebook CAPI settings
  const metaCapiSettings = settings.find((setting) => setting.service_name === 'MetaCapi') as
    | AnalyticsServiceSettings<{ pixel_id: string; meta_access_token: string }, object>
    | undefined

  // If the service is not enabled, return undefined
  if (metaCapiSettings?.status !== 'enabled') {
    return undefined
  }

  return {
    name: 'facebook-capi',
    /**
     * Initializes the plugin.
     */
    initialize: () => {
      return true
    },
    /**
     * Handles page events, using Facebook CAPI to track page views.
     */
    page: ({ payload }: { payload: { event: string; properties: object } }) => {
      /**
       * We've disabled the page view tracking for now, as it can cause duplication
       * with the customer's own page tracking.
       */
      // const channelEventObject = buildChannelEventObject('ViewContent', payload.properties)
      // dispatch(
      //   createChannelEvent.initiate({
      //     oid: organizationId,
      //     body: channelEventObject,
      //   }),
      // )
    },
    /**
     * Handles tracking custom events, sending them to the Facebook CAPI.
     */
    track: ({ payload }: { payload: { event: string; properties: object } }) => {
      const channelEventObject = buildChannelEventObject(payload.event, payload.properties)

      dispatch(
        createChannelEvent.initiate({
          oid: organizationId,
          body: channelEventObject,
        }),
      )
    },
    /**
     * Returns whether the plugin is loaded.
     */
    loaded: (): boolean => {
      return true
    },
  }
}

/**
 * Calls the organization channel events API endpoint.
 * This function sends the event object to the backend service.
 *
 * @param oid - Organization ID
 * @param channelEventObject - Event object to send
 * @returns {Promise<Response>} - The response from the API
 */
export const callOrganizationChannelEventsEndpoint = async (
  oid: string,
  channelEventObject: object,
) => {
  const response = await fetch(`/api/organizations/${oid}/channel-events`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(channelEventObject),
  })

  return response
}

export default makeFacebookCapiAnalyticsPlugin
